export interface ILicenseTransferLogItem {
    ID: number;
    DateTimeCreated: Date;
    IP: string;
    RegistrationKey: string;
    TargetID: string;
    CountTowardsLimit: boolean;
    Note: string;

}

export class LicenseTransferLogArray extends Array<TransferLogItem>  {

    constructor(...items: TransferLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, LicenseTransferLogArray.prototype);
    }

    public static FixDates(items: LicenseTransferLogArray) {
        items.forEach(x => TransferLogItem.FixDates(x));
    }
}

export class TransferLogItem implements ILicenseTransferLogItem {
    ID: number;
    DateTimeCreated: Date;
    IP: string;
    RegistrationKey: string;
    TargetID: string;
    CountTowardsLimit: boolean;
    Note: string;

    LicenseID: number;
    LicenseKey: string;

    MemberID: number;
    MemberName: string;

    public static FixDates(item: TransferLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}
